import React, { FC } from 'react';
import styled from '@emotion/styled';
import Button from '@app/components/Button';
import { SendValidationEmailToPayeeFormFields } from './SendValidationEmailToPayeeForm';
import { BodyRegularStartTransparentBlack600 } from '@app/components/Text';
import DataGrid, { DataGridRow } from '@app/components/DataGrid';

interface Props {
  values: SendValidationEmailToPayeeFormFields;
  className?: string;
  onOk(values: SendValidationEmailToPayeeFormFields): void;
  onBack(): void;
}

const SendValidationEmailToPayeeSummary: FC<Props> = ({ values, onOk, onBack, className }) => {
  return (
    <Main className={className}>
      <SummaryExplanation>Check the information provided before sending the email</SummaryExplanation>
      <DetailsGrid>
        <DataGridRow title='To:' valueDataTest='txtToAddresses'>
          <EmailsList>
            {values.to.map((value) => (
              <li key={value}>{value}</li>
            ))}
          </EmailsList>
        </DataGridRow>
      </DetailsGrid>
      <ActionsContainer>
        <BackButton id='btn-send-validation-email-to-payee-summary-back' appearance='text' colorScheme='grey' onClick={onBack}>
          {'<'} BACK
        </BackButton>
        <Button id='btn-send-validation-email-to-payee-summary-ok' onClick={(): void => onOk(values)}>
          SEND EMAIL
        </Button>
      </ActionsContainer>
    </Main>
  );
};

export default SendValidationEmailToPayeeSummary;

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailsGrid = styled(DataGrid)`
  flex: 1;
  --info-row-font-size: 15px;
`;

const EmailsList = styled.ul`
  padding-inline-start: 20px;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 0 0 auto;

  // To allow the buttons drop shadow to fully show
  padding: 10px var(--side-padding) 8px;

  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;

const BackButton = styled(Button)`
  margin-left: calc(var(--button-line-padding) * -1);
`;

const SummaryExplanation = styled(BodyRegularStartTransparentBlack600.div)`
  margin-bottom: 16px;
`;
